import React from 'react';
import { MapContainer, TileLayer, Rectangle, useMap } from 'react-leaflet';
import L, { type LatLngBounds } from 'leaflet';
import { getMapTilerStreetTileLayerConfig } from '../../config/mapTiles';

interface BoundingBoxMapProps {
  boundingBox: {
    minLat: number;
    maxLat: number;
    minLng: number;
    maxLng: number;
  };
  height?: string;
  className?: string;
}

// Component to fit the map to bounds
const FitBounds: React.FC<{ bounds: LatLngBounds }> = ({ bounds }) => {
  const map = useMap();
  
  React.useEffect(() => {
    map.fitBounds(bounds, { padding: [20, 20] });
  }, [map, bounds]);
  
  return null;
};

export function BoundingBoxMap({ 
  boundingBox, 
  height = "400px",
  className = ""
}: BoundingBoxMapProps) {
  // Create bounds array for react-leaflet Rectangle
  const bounds: [[number, number], [number, number]] = [
    [boundingBox.minLat, boundingBox.minLng], // Southwest corner
    [boundingBox.maxLat, boundingBox.maxLng]  // Northeast corner
  ];

  // Calculate center point
  const center: [number, number] = [
    (boundingBox.minLat + boundingBox.maxLat) / 2,
    (boundingBox.minLng + boundingBox.maxLng) / 2
  ];

  // Create LatLngBounds object for FitBounds component
  const latLngBounds = new L.LatLngBounds(bounds);
  const tiles = getMapTilerStreetTileLayerConfig();

  return (
    <div className={`rounded-lg border border-gray-200 overflow-hidden ${className}`}>
      <MapContainer 
        center={center} 
        zoom={6} 
        style={{ height, width: "100%" }}
        className="z-0"
      >
        <TileLayer
          url={tiles.url}
          attribution={tiles.attribution}
          maxZoom={tiles.maxZoom}
        />
        <Rectangle 
          bounds={bounds} 
          pathOptions={{ 
            color: 'rgb(59, 130, 246)', // Blue-500
            weight: 2,
            fillColor: 'rgb(59, 130, 246)',
            fillOpacity: 0.1 
          }} 
        />
        <FitBounds bounds={latLngBounds} />
      </MapContainer>
    </div>
  );
} 